<template>
  <div>
    <b-row>
      <b-col md="3">
        <input-select-search
          ref="anoLetivoId"
          :label="$t(`ACADEMICO.ANOS`)"
          :options="opcoes.anosLetivos"
          v-model="filtro.anoLetivoId"
          :placeholder="$t('GERAL.DIGITE_OU_PROCURE')"
          @input="obterSegmentacao()"
          required
        />
      </b-col>
      <b-col md="3">
        <input-select-search
          ref="bimestreId"
          :label="$t(`ACADEMICO.TRIMESTRE`)"
          :options="opcoes.segmentacoes"
          :placeholder="$t('GERAL.DIGITE_OU_PROCURE')"
          v-model="filtro.segmentacaoId"
          @input="obterDisciplinas()"
          :isDisabled="!filtro.anoLetivoId"
          required
        />
      </b-col>
      <b-col md="3">
        <input-select-search
          ref="disciplinaId"
          :label="$t(`ACADEMICO.DISCIPLINA`)"
          :placeholder="$t('GERAL.DIGITE_OU_PROCURE')"
          :options="opcoes.disciplinas"
          v-model="filtro.disciplinaId"
          :isDisabled="!filtro.segmentacaoId"
          required
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col md="auto">
        <b-button class="w-100 mb-3" variant="primary" @click="filtrar">
          {{ $t("ACADEMICO.OBTER_NOTAS_PARCIAIS") }}
        </b-button>
      </b-col>
      <b-col md="auto">
        <b-button class="w-100 mb-3" variant="secondary" @click="limparFiltro">
          {{ $t("GERAL.LIMPAR") }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import helpers from "@/common/utils/helpers";
import mensagem from "@/common/utils/mensagem";
// import JwtService from "@/common/utils/jwt";

// Components:
import { InputSelectSearch } from "@/components/inputs";

// Services
import SegmentacaoService from "@/common/services/segmentacao/segmentacao.service.js";
import DisciplinasService from "@/common/services/academico/disciplinas.service.js";
import AnoLetivoService from "@/common/services/ano-letivo/ano-letivo.service";

export default {
  components: {
    InputSelectSearch,
  },
  data() {
    return {
      opcoes: {
        alunosVinculados: [],
        anosLetivos: [],
        segmentacoes: [],
        disciplinas: [],
      },
      filtro: {
        matriculaId: null,
        anoLetivoId: null,
        segmentacaoId: null,
        disciplinaId: null,
      },
      camposDesabilitados: false,
    };
  },

  mounted() {
    this.obterPeriodoLetivo();
  },
  methods: {
    obterPeriodoLetivo() {
      this.$store.dispatch(START_LOADING);
      AnoLetivoService.obterPeriodoLetivo()
        .then(({ data }) => {
          this.opcoes.anosLetivos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => this.$store.dispatch(STOP_LOADING));
    },
    obterSegmentacao() {
      this.filtro.segmentacaoId = null;
      this.filtro.disciplinaId = null;
      this.opcoes.segmentacoes = [];
      this.opcoes.disciplinas = [];
      if (!this.filtro.anoLetivoId) return;
      this.$emit("limpar-dados");
      this.$store.dispatch(START_LOADING);
      SegmentacaoService.pegarPorAnoLetivoId(this.filtro.anoLetivoId)
        .then(({ data }) => {
          data = data.map((seg) => ({
            text: seg.descricao,
            value: seg.id,
          }));

          data.sort((a, b) => a.text.localeCompare(b.text));

          this.opcoes.segmentacoes =
            data.length > 0
              ? data
              : [
                  {
                    text: this.$t("ACADEMICO.NENHUMA_SEGMENTACAO"),
                    value: null,
                  },
                ];
        })
        .catch(() => {
          this.filtro.bimestreId = null;
          this.opcoes.segmentacoes = [
            {
              text: this.$t("ACADEMICO.NENHUMA_SEGMENTACAO"),
              value: null,
            },
          ];
        })
        .finally(() => this.$store.dispatch(STOP_LOADING));
    },
    obterDisciplinas() {
      this.opcoes.disciplinas = [];
      this.filtro.disciplinaId = null;
      if (!this.filtro.segmentacaoId) return;
      this.$emit("limpar-dados");
      this.$store.dispatch(START_LOADING);
      DisciplinasService.buscarDisciplinasPorAnoLetivoIdSemDocente(
        this.filtro.anoLetivoId
      )
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            text: row.descricao,
            value: row.id,
          }));

          data.sort((a, b) => a.text.localeCompare(b.text));

          this.opcoes.disciplinas =
            data.length > 0
              ? data
              : [
                  {
                    text: this.$t("ACADEMICO.NENHUMA_DISCIPLINA"),
                    value: null,
                  },
                ];
        })
        .catch(() => {
          this.filtro.disciplinaId = null;
          this.opcoes.disciplinas = [
            {
              text: this.$t("ACADEMICO.NENHUMA_DISCIPLINA"),
              value: null,
            },
          ];
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    // FUNÇÕES DO FILTRO:
    filtrar() {
      if (!this.validarFiltro()) return;
      this.$emit("filtrar", this.filtro);
    },

    validarFiltro() {
      return helpers.validarFormulario(this.$refs);
    },

    limparFiltro() {
      this.filtro =
        this.opcoes.alunosVinculados.length > 0
          ? {
              anoLetivoId: null,
              segmentacaoId: null,
              disciplinaId: null,
            }
          : {
              ...this.filtro,
              anoLetivoId: null,
              segmentacaoId: null,
              disciplinaId: null,
            };
      this.$emit("limpar-filtro");
    },
  },
};
</script>
